import React, { useEffect } from 'react'
import Header from '../header/header'
import { SummaryCard } from '../../components/SummaryCard'
import Portfolio from "../portfolio/interface/Allocation"
import { useDispatch, useSelector } from 'react-redux'
import { getDashboard } from '../../redux/dashboard/dashboard'
function Index() {
    const dispatch = useDispatch();
    const userDetail = useSelector(state => state.auth.userDetail)
    const Data = useSelector(state => state.dashboard.data)

    useEffect(() => {
        dispatch(getDashboard())
    }, [])

    const formatPercent = (percent) => `${Number(percent).toFixed(2)}%`;
    return (
        <div>
            <Header />
            {(userDetail.wealthInvestmentAmt && userDetail.multibaggerAllocation) ?
                <section className="text-body-emphasis bg-body-tertiary">
                    <div className="container py-5">
                        <div className="row g-3 justify-content-center">
                            {/* Investment Summary */}
                            <div className="col-md-10">
                                <div className="border p-3 rounded-3 shadow-sm bg-body shine-effect w-100">
                                    <h1 className="fs-4 fw-bold">
                                        Hi, {userDetail?.firstName ?? ''} {userDetail?.lastName ?? ''}
                                    </h1>
                                    <span
                                        style={{
                                            background: 'linear-gradient(to right, #C609FA, #3959FE, #0E9EEE)',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent',
                                            display: 'inline-block',
                                        }}
                                    >
                                        Welcome to WealthX
                                    </span>
                                    <hr />
                                    <div className="row g-3">
                                        <div className="col-md-12">
                                            <div className="d-flex align-items-baseline">
                                                <p className="fw-bold mb-0">Your Investment Summary</p>
                                            </div>
                                            <small className="text-muted">
                                                As on {new Date().toLocaleDateString('en-GB', {
                                                    day: '2-digit',
                                                    month: 'long',
                                                    year: 'numeric',
                                                })}
                                            </small>
                                        </div>

                                        {[
                                            { label: "Total Investment", value: Data?.invested?.toFixed(2) },
                                            { label: "Current Value", value: Data?.currentValue?.toFixed(2) },

                                            {
                                                label: "Overall P&L",
                                                value: Data?.overallPLAmt,
                                                percent: `${Data?.overallPLPer || 0.00}%`,
                                            },
                                            {
                                                label: "Day's P&L ",
                                                value: Data?.daysPLAmt,
                                                percent: `${Data?.daysPLPer || 0.00}%`,
                                            },
                                        ].map((item, index) => {
                                            const formattedValue =
                                                item.value != null ? Number(item.value).toLocaleString('en-IN') : '--';
                                            const percentValue = parseFloat(item?.percent?.replace('%', ''));
                                            return (
                                                <div key={index} className="col-lg-3 col-md-3 col-6">
                                                    <div>
                                                        <small className="text-muted">{item.label}</small>
                                                        {item.percent ? (
                                                            <div className="d-flex align-items-baseline">
                                                                <h6 className={`text-${Number(item.value) > 0 ? "green" : "red"} mb-0`}>{formattedValue}</h6>
                                                                <small className={`text-${percentValue > 0 ? "green" : "red"} ms-2`}>
                                                                    {item.percent}
                                                                </small>
                                                            </div>
                                                        ) : (
                                                            <h6 className="mb-0">{formattedValue}</h6>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>

                            {/* My Portfolio */}
                            <div className="col-md-5">
                                <SummaryCard
                                    title="🛍️ My Portfolio"
                                    values={{
                                        fund: Data?.portfolio?.availableFunds,
                                        invested: Data?.portfolio?.invested,
                                        investment: Data?.portfolio?.investedAmount,
                                        current: Data?.portfolio?.currentValue,
                                        dayPL: { value: Data?.portfolio?.daysPLAmt, percent: Data?.portfolio?.daysPLPer },
                                        overallPL: { value: Data?.portfolio?.overallPLAmt, percent: Data?.portfolio?.overallPLPer },
                                    }}
                                    path="/portfolio"
                                />
                            </div>

                            {/* My Multibaggers */}
                            <div className="col-md-5">
                                <SummaryCard
                                    title="🚀 My Multibaggers"
                                    values={{
                                        invested: Data?.multibagger?.invested,
                                        current: Data?.multibagger?.currentValue,
                                        dayPL: { value: Data?.multibagger?.daysPLAmt, percent: Data?.multibagger?.daysPLPer },
                                        overallPL: { value: Data?.multibagger?.overallPLAmt, percent: Data?.multibagger?.overallPLPer },
                                    }}
                                    path="/multibagger"
                                />
                            </div>
                        </div>
                    </div>
                </section> : <Portfolio />}
        </div>
    )
}

export default Index



